<template>
  <div class="wrapper">
    <opus-header :title="opus.anthName"
                 :image="opus.portrait"/>
    <cube-scroll ref="scroll"
                 :options="options"
                 :data="comments"
                 @pulling-up="onPullingUp">
      <component :is="formatView"
                 :content="content"/>
      <split/>
      <opus-comment :opus="opus"
                    :comments="comments"/>
    </cube-scroll>
  </div>

</template>

<script>
  import axios from 'axios'
  import OpusHeader from './comps/Header'
  import VerseContent from './comps/content/VerseContent'
  import BlogContent from './comps/content/BlogContent'
  import EssayContent from './comps/content/EssayContent'
  import OpusComment from './comps/Comment'
  import Split from 'common/comps/split/Split'

  import moment from 'moment'

  export default {
    name: 'opus-detail',
    components: {
      OpusHeader,
      VerseContent,
      BlogContent,
      EssayContent,
      OpusComment,
      Split
    },
    data() {
      return {
        opus: {},
        content: {},
        comments: [],
        options: {
          pullUpLoad: {
            threshold: 0,
            txt: {
              more: '上拉加载更多',
              noMore: '评论已加载完毕'
            }
          }
        },
        state: {
          hasData: false,
          hasMoreData: false,
          timeStamp: '0'
        }
      }
    },
    computed: {
      formatView() {
        if (this.opus.format === 'VERSE') {
          return 'VerseContent'
        } else if (this.opus.format === 'BLOG') {
          return 'BlogContent'
        } else {
          return 'EssayContent'
        }
      }
    },
    methods: {
      _getOpus() {
        const opusId = this.$route.params.opusId
        axios.get('/api/opus/' + opusId).then((res) => {
          const { code, result } = res.data
          if (code === 1) {
            this.opus = result

            if (this.opus) {
              this.content = JSON.parse(this.opus.content)

              if (this.opus.type === 8) {
                this.opus.format = 'BLOG'
              } else if (this.content.ruleInfo) {
                this.opus.format = 'VERSE'
              } else {
                this.opus.format = 'ESSAY'
              }
            }
          }
        }).catch((e) => {
        })
      },
      _getComments() {
        const opusId = this.$route.params.opusId
        axios.get('/api/cmt/opus/' + opusId + '/' + this.state.timeStamp)
          .then((res) => {
            const { code, result } = res.data
            if (code === 1) {
              if (result.length > 0) {
                this.state.hasData = true
                if (result.length === 20) {
                  this.state.hasMoreData = true
                }

                const last = result[result.length - 1]
                this.state.timeStamp = moment(last.createAt).format('x')

                this.comments = this.comments.concat(result)
              } else {
                this.state.hasData = false
                this.state.hasMoreData = false
              }
            }
          }).catch((e) => {
        })
      },
      onPullingUp() {
        if (!this.state.hasMoreData) {
          this.$refs.scroll.forceUpdate()
          return
        }

        this._getComments()

        setTimeout(() => {
          this.$refs.scroll.forceUpdate(this.state.hasData)
        }, 3000)
      }
    },
    mounted() {
      this._getOpus()
      this._getComments()
    }
  }
</script>

<style lang="stylus" scoped>
  .wrapper
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
</style>
